(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Flickity"), require("GLightbox"), require("bootstrap"), require("mitt"));
	else if(typeof define === 'function' && define.amd)
		define([, , , ], factory);
	else if(typeof exports === 'object')
		exports["App"] = factory(require("Flickity"), require("GLightbox"), require("bootstrap"), require("mitt"));
	else
		root["App"] = factory(root["Flickity"], root["GLightbox"], root["bootstrap"], root["mitt"]);
})(window, (__WEBPACK_EXTERNAL_MODULE__7817__, __WEBPACK_EXTERNAL_MODULE__9402__, __WEBPACK_EXTERNAL_MODULE__1744__, __WEBPACK_EXTERNAL_MODULE__2218__) => {
return 